module.exports = __webpack_public_path__ + "img/1736404043395-NIB LOAFOOD.png.53527f9e.webp";